import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import {
    FormControlLabel,
    Checkbox,
    FormGroup,
    List,
    ListItem,
    Typography,
    FormLabel,
    Radio,
    RadioGroup,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Autocomplete,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import axios from "../../../../lib/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import axiosInstance from "../../../../lib/axios";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";
import { useReactToPrint } from "react-to-print";
import { getFormMode } from "../../../../lib/helpers";
import GstRateTable from "./GstRateTable";
import { z } from "zod";

const FORM_MODE = getFormMode();

const FORM_INIT_STATE = {
    HsnSubChp_Key: "",
    HsnChp_Key: "",
    HsnSubChap_Name: "",
    HsnSubChap_Desc: "",
    Remk: "",
    Multi_Sab: "S",
    Mrp_Wsp_App: "M",
    Taxable_Exempted: "T",
    Status: FORM_MODE.add ? "1" : "0",
};

const columns = [
    { id: "RowNum", label: "Sr.No.", minWidth: 5 },
    { id: "HsnSubChp_Key", label: "Key", minWidth: 100 },
    { id: "HsnSubChap_Name", label: "Name", minWidth: 100 },
    { id: "HsnChap_Name", label: "ChapNm", minWidth: 100 },
    { id: "Multi_Sab", label: "RateSlab", minWidth: 100 },
    { id: "Mrp_Wsp_App", label: "AlicableOn", minWidth: 100 },
    { id: "Taxable_Exempted", label: "GstAppl.", minWidth: 100 },
    { id: "HsnSubChap_Desc", label: "Desc", minWidth: 100 },
    { id: "Status", label: "Status", minWidth: 50 },
];
const DEFAULT_ROW = {
    BASERate: "1",
    BASERateTo: "0",
    BaseRateIncl: "0",
    BaseRateInclTo: "0",
    SGSTRate: "0",
    CGSTRate: "0",
    IGSTRate: "0",
    AddCESS: "0",
};

const GstSubChapHdMst = () => {
    const [formData, setFormData] = useState(FORM_INIT_STATE);
    const navigate = useNavigate();
    const [UserId, setUserId] = useState(sessionStorage.getItem("UserId"));
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [location, setLocation] = useState(useLocation());
    const [vendor, setVendor] = useState([]);
    // const [Status, setStatus] = useState("1");
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const [selectedVendorIds, setSelectedVendorIds] = useState([]);
    const [gstRateSlab, setGstRateSlab] = useState("Single");
    const [gstApplication, setGstApplication] = useState("Taxable");
    const [applicableOn, setApplicableOn] = useState("RSP/MRP");
    const [gstRateRows, setGstRateRows] = useState([])
    const [gstChapterOptions, setGstChapterOptions] = useState([]);
    const [gstPeriodOptions, setGstPeriodOptions] = useState([]);
    const [loadingPeriod, setLoadingPeriod] = useState(true);

    const [currentHsnSubChp_Key, setCurrentHsnSubChp_Key] = useState(() => {
        if (location.state && location.state?.HsnSubChp_Key) {
            return location.state && location.state?.HsnSubChp_Key;
        }
        return undefined;
    });
    const [mode, setMode] = useState(() =>
        currentHsnSubChp_Key ? FORM_MODE.read : FORM_MODE.add
    );

    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState({
        isOpen: false,
        payload: null,
    });

    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const RemkRef = useRef(null);
    const HsnSubChap_DescRef = useRef(null);
    const HsnSubChap_NameRef = useRef(null);
    const HsnSubChp_KeyRef = useRef(null);

    /* -----------------------  FETCH CHAPTERS  ----------------------- */
    useEffect(() => {
        const fetchChapters = async () => {
            try {
                const res = await axiosInstance.post("/HsnCode/getGstChapdrp", {
                    HsnChp_Key: "",
                    Flag: "",
                });
                if (res.data.Status === 0 && Array.isArray(res.data.Data)) {
                    const options = res.data.Data.map((item) => ({
                        label: `${item.HsnChap_Name} - ${item.HsnChap_Desc || ""}`.trim(),
                        // label: ` ${item.HsnChap_Name || ""}`.trim(),
                        value: item.HsnChp_Key,
                    }));
                    setGstChapterOptions(options);

                    // Auto-select first only in Add mode
                    if (mode === FORM_MODE.add && options.length > 0) {
                        setFormData((prev) => ({
                            ...prev,
                            HsnChp_Key: options[0].value,
                        }));
                    }
                }
            } catch (e) {
                toast.error("Failed to load GST Chapters");
            }
        };
        fetchChapters();
    }, [mode]);
    /* -----------------------  FETCH PERIODS  ----------------------- */

    // useEffect(() => {
    //     const fetchPeriods = async () => {
    //         try {
    //             const res = await axiosInstance.post("/HsnCode/getGstSubChapdrp", {
    //                 HsnChp_Key: "",
    //                 Flag: "GSTRATE_PERIOD",
    //             });

    //             if (res.data.Status === 0 && Array.isArray(res.data.Data)) {
    //                 const validPeriods = res.data.Data.filter(
    //                     (item) => item.Id != null
    //                 );

    //                 const options = validPeriods.map((item) => ({
    //                     label: item.Name && item.Name.trim() !== ""
    //                         ? item.Name.trim()
    //                         : "",
    //                     //    : "(No Period)",
    //                     value: String(item.Id),
    //                     from: item.CheckingDt,
    //                     to: item.CheckedOutDt,
    //                 }));

    //                 setGstPeriodOptions(options);

    //                 if (mode === FORM_MODE.add && options.length > 0) {
    //                     const first = options[0];

    //                     const fromDate = first.from?.split("T")[0] || "";
    //                     const toDate = first.to?.split("T")[0] || "";

    //                     setFormData(prev => ({
    //                         ...prev,
    //                         GstPeriods_Key: first.value,
    //                         FromDate: fromDate,
    //                         ToDate: toDate,
    //                     }));
    //                 }
    //             }
    //         } catch (e) {
    //             toast.error("Failed to load GST Periods");
    //         }
    //     };

    //     fetchPeriods();
    // }, []);

    /* -----------------------  FETCH PERIODS  ----------------------- */
    useEffect(() => {
        const fetchPeriods = async () => {
            setLoadingPeriod(true);
            try {
                const res = await axiosInstance.post("/HsnCode/getGstSubChapdrp", {
                    HsnChp_Key: "",
                    Flag: "GSTRATE_PERIOD",
                });

                if (res.data.Status !== 0 || !Array.isArray(res.data.Data)) {
                    toast.error("Failed to load GST Periods");
                    return;
                }

                // -----------------------------------------------------------------
                // 1. Build options + keep raw dates for later use
                // -----------------------------------------------------------------
                const rawOptions = res.data.Data.map(item => ({
                    id: item.Id,
                    name: item.Name?.trim() ?? "",
                    from: item.CheckingDt,      // e.g. "2025-09-22T00:00:00"
                    to: item.CheckedOutDt,    // e.g. "2031-09-22T00:00:00"
                }));

                const options = rawOptions.map(o => ({
                    label: o.name || "(no period)",
                    value: String(o.id),
                    from: o.from.split("T")[0],
                    to: o.to.split("T")[0],
                }));

                setGstPeriodOptions(options);

                // -----------------------------------------------------------------
                // 2. Helper – is a given date inside a period?
                // -----------------------------------------------------------------
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const findCurrent = () => {
                    for (const opt of rawOptions) {
                        const start = new Date(opt.from);
                        const end = new Date(opt.to);
                        start.setHours(0, 0, 0, 0);
                        end.setHours(0, 0, 0, 0);
                        if (today >= start && today <= end) return opt;
                    }
                    return null;
                };

                const currentPeriod = findCurrent();

                // -----------------------------------------------------------------
                // 3. Auto-select logic
                // -----------------------------------------------------------------
                if (mode === FORM_MODE.add && currentPeriod) {
                    // ---- ADD mode – pick current period (first time) ----
                    const { id, from, to } = currentPeriod;
                    setFormData(prev => ({
                        ...prev,
                        GstPeriods_Key: String(id),
                        FromDate: from.split("T")[0],
                        ToDate: to.split("T")[0],
                    }));
                } else if (mode !== FORM_MODE.add && formData.GstPeriods_Key) {
                    // ---- EDIT / READ mode – keep saved value, but fallback to current ----
                    const saved = options.find(o => o.value === formData.GstPeriods_Key);
                    if (saved) {
                        // already correct – just make sure dates are in sync
                        setFormData(prev => ({
                            ...prev,
                            FromDate: saved.from,
                            ToDate: saved.to,
                        }));
                    } else if (currentPeriod) {
                        // saved period not found → switch to current
                        const { id, from, to } = currentPeriod;
                        setFormData(prev => ({
                            ...prev,
                            GstPeriods_Key: String(id),
                            FromDate: from.split("T")[0],
                            ToDate: to.split("T")[0],
                        }));
                    }
                }
            } catch (e) {
                toast.error("Failed to load GST Periods");
                console.error(e);
            } finally {
                setLoadingPeriod(false);
            }
        };

        fetchPeriods();
    }, [mode]);


    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axiosInstance.post('HsnCode/GetGstSubChapDashBoard', {
                    start: 1,
                    PageSize: 1,
                    SearchText: "",
                });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                } else {
                    console.error('No data found in response');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    /* -----------------------  HANDLE LOCATION STATE  ----------------------- */
    useEffect(() => {
        const state = location.state;
        if (!state) {
            setMode(FORM_MODE.add);
            setIsFormDisabled(false);
            return;
        }

        if (state.mode === "add" && state.HsnSubChp_Key) {
            // New record with pre-generated key
            setCurrentHsnSubChp_Key(state.HsnSubChp_Key);
            setMode(FORM_MODE.add);
            setIsFormDisabled(false);
            setFormData({
                ...FORM_INIT_STATE,
                HsnSubChp_Key: state.HsnSubChp_Key,
                HsnChp_Key: state.HsnChp_Key ?? "",
                Status: "1",
            });
            setTimeout(() => HsnSubChap_NameRef.current?.focus(), 100);
        } else if (state.HsnSubChp_Key && state.mode === "view") {
            setCurrentHsnSubChp_Key(state.HsnSubChp_Key);
            fetchRetriveData(state.HsnSubChp_Key, "R");
            setMode(FORM_MODE.read);
        } else {
            setMode(FORM_MODE.add);
            setIsFormDisabled(false);
        }
    }, [location.state]);


    // Sync GstPeriods_Key with options when they load

    useEffect(() => {
        console.log("Sync effect triggered:", {
            options: gstPeriodOptions.map(o => ({ label: o.label, value: o.value, type: typeof o.value })),
            selectedKey: formData.GstPeriods_Key,
            typeofKey: typeof formData.GstPeriods_Key,
            found: gstPeriodOptions.find(opt => opt.value === formData.GstPeriods_Key)
        });

        if (
            gstPeriodOptions.length > 0 &&
            formData.GstPeriods_Key &&
            mode !== FORM_MODE.add
        ) {
            const selected = gstPeriodOptions.find(
                opt => opt.value === formData.GstPeriods_Key
            );

            if (selected) {
                // ... set dates
            } else {
                console.warn("GST Period not found in options!", formData.GstPeriods_Key);
            }
        }
    }, [gstPeriodOptions, formData.GstPeriods_Key, mode]);

    /* -----------------------  RETRIEVE RECORD  ----------------------- */

    // const fetchRetriveData = async (id, flag = "") => {
    //     if (!id) return;
    //     try {
    //         const res = await axiosInstance.post(
    //             "HsnCode/RetriveGstSubChapAll",
    //             { HsnSubChp_Key: id, Flag: flag }
    //         );
    //         const { Status, Data } = res.data;
    //         if (Status !== 0 || !Data?.GstSubChapSlabEntities?.[0]) {
    //             return;
    //         }

    //         const rec = Data.GstSubChapSlabEntities[0];

    //         /* ---------- MAP DATES FROM API ---------- */
    //         const fromDate = rec.CheckingDt?.split("T")[0] || "";
    //         const toDate = rec.CheckedOutDt?.split("T")[0] || "";

    //         setFormData(prev => ({
    //             ...prev,
    //             HsnSubChp_Key: rec.HsnSubChp_Key,
    //             HsnChp_Key: rec.HsnChp_Key ?? "",
    //             HsnSubChap_Name: rec.HsnSubChap_Name ?? "",
    //             HsnSubChap_Desc: rec.HsnSubChap_Desc ?? "",
    //             GstPeriods_Key: rec.GST_P_ID?.toString() || "",
    //             Remk: rec.Remk ?? "",
    //             Multi_Sab: rec.Multi_Sab ?? "S",
    //             Mrp_Wsp_App: rec.MRP_WSP_APP ?? "M",
    //             Taxable_Exempted: rec.Taxable_Exempted ?? "T",
    //             Status: rec.Status ?? "1",
    //             // <-- Fill the date fields here
    //             FromDate: fromDate,
    //             ToDate: toDate,
    //         }));

    //         setGstApplication(rec.Taxable_Exempted === "T" ? "Taxable" : "Exempted");
    //         setGstRateSlab(rec.Multi_Sab === "M" ? "Multiple" : "Single");
    //         setApplicableOn(rec.Mrp_Wsp_App === "M" ? "RSP/MRP" : "NetSaleRs");

    //         /* ---------- GST Rate Slabs ---------- */
    //         if (Array.isArray(rec.gst_Rate_SlabEntities)) {
    //             const isMultiple = rec.Multi_Sab === "M";
    //             const mapped = rec.gst_Rate_SlabEntities.map((s) => ({
    //                 Gst_Rate_Slab_Id: s.Gst_Rate_Slab_Id ?? 0,  // ← Keep even if 0
    //                 BASERate: isMultiple ? (s.Base_Rate?.toString() ?? "1") : "0",
    //                 BASERateTo: isMultiple ? (s.Base_Rate_To?.toString() ?? "0") : "0",
    //                 BaseRateIncl: "0",
    //                 BaseRateInclTo: "0",
    //                 SGSTRate: s.Sgst_Rate?.toString() ?? "0",
    //                 CGSTRate: s.Cgst_Rate?.toString() ?? "0",
    //                 IGSTRate: s.Igst_Rate?.toString() ?? "0",
    //                 AddCESS: s.Add_Cess?.toString() ?? "0",
    //             }));

    //             // If Single mode, force only 1 row
    //             if (!isMultiple && mapped.length > 0) {
    //                 setGstRateRows([mapped[0]]);
    //             } else {
    //                 setGstRateRows(mapped.length > 0 ? mapped : [DEFAULT_ROW]);
    //             }
    //         } else {
    //             // No data from API → use correct default
    //             setGstRateRows(rec.Multi_Sab === "M" ? [{
    //                 ...DEFAULT_ROW,
    //                 BASERate: "1"
    //             }] : [{
    //                 ...DEFAULT_ROW,
    //                 BASERate: "0",
    //                 BASERateTo: "0"
    //             }]);
    //         }

    //         setCurrentHsnSubChp_Key(rec.HsnSubChp_Key);
    //         setIsFormDisabled(true);
    //     } catch (e) {
    //         toast.error("Failed to load record");
    //         console.error(e);
    //     }
    // };

    /* --------------------------------------------------------------- */
    /*  RETRIEVE RECORD – fill every field from the API response       */
    /* --------------------------------------------------------------- */
    const fetchRetriveData = async (id, flag = "") => {
        if (!id) return;

        try {
            const res = await axiosInstance.post(
                "HsnCode/RetriveGstSubChapAll",
                { HsnSubChp_Key: id, Flag: flag }
            );

            const { Status, Data } = res.data;
            if (Status !== 0 || !Data?.GstSubChapSlabEntities?.[0]) {
                toast.error("Record not found");
                return;
            }

            const rec = Data.GstSubChapSlabEntities[0];

            /* ---------- DATES (From / To) ---------- */
            const fromDate = rec.CheckingDt?.split("T")[0] || "";
            const toDate = rec.CheckedOutDt?.split("T")[0] || "";

            /* ---------- MAIN FORM ---------- */
            setFormData({
                HsnSubChp_Key: rec.HsnSubChp_Key ?? "",
                HsnChp_Key: rec.HsnChp_Key ?? "",
                HsnSubChap_Name: rec.HsnSubChap_Name ?? "",
                HsnSubChap_Desc: rec.HsnSubChap_Desc ?? "",
                Remk: rec.Remk ?? "",
                Multi_Sab: rec.Multi_Sab ?? "S",
                Mrp_Wsp_App: rec.MRP_WSP_APP ?? "M",   // API uses MRP_WSP_APP
                Taxable_Exempted: rec.Taxable_Exempted ?? "T",
                Status: rec.Status ?? "1",
                GstPeriods_Key: rec.GST_P_ID?.toString() ?? "",
                FromDate: fromDate,
                ToDate: toDate,
            });

            /* ---------- RADIO / SELECT HELPERS ---------- */
            setGstApplication(rec.Taxable_Exempted === "T" ? "Taxable" : "Exempted");
            setGstRateSlab(rec.Multi_Sab === "M" ? "Multiple" : "Single");
            setApplicableOn(rec.MRP_WSP_APP === "M" ? "RSP/MRP" : "NetSaleRs");

            /* ---------- GST RATE SLAB ROWS ---------- */
            const isMultiple = rec.Multi_Sab === "M";

            if (Array.isArray(rec.gst_Rate_SlabEntities) && rec.gst_Rate_SlabEntities.length) {
                const mapped = rec.gst_Rate_SlabEntities.map(s => ({
                    Gst_Rate_Slab_Id: s.Gst_Rate_Slab_Id ?? 0,
                    BASERate: isMultiple ? (s.Base_Rate?.toString() ?? "1") : "0",
                    BASERateTo: isMultiple ? (s.Base_Rate_To?.toString() ?? "0") : "0",
                    BaseRateIncl: s.Base_Rate_Incl?.toString() ?? "0",
                    BaseRateInclTo: s.Base_Rate_Incl_To?.toString() ?? "0",
                    SGSTRate: s.Sgst_Rate?.toString() ?? "0",
                    CGSTRate: s.Cgst_Rate?.toString() ?? "0",
                    IGSTRate: s.Igst_Rate?.toString() ?? "0",
                    AddCESS: s.Add_Cess?.toString() ?? "0",
                }));

                // Single-mode → keep only the first row (the rest are irrelevant)
                setGstRateRows(isMultiple ? mapped : [mapped[0]]);
            } else {
                // No slab rows → default according to mode
                const def = {
                    ...DEFAULT_ROW,
                    BASERate: isMultiple ? "1" : "0",
                    BASERateTo: isMultiple ? "0" : "0",
                };
                setGstRateRows([def]);
            }

            setCurrentHsnSubChp_Key(rec.HsnSubChp_Key);
            setIsFormDisabled(true);
        } catch (e) {
            toast.error("Failed to load record");
            console.error(e);
        }
    };
    /* -----------------------  NAVIGATION  ----------------------- */
    const navigateRecord = async (flag) => {
        if (!currentHsnSubChp_Key) return;
        try {
            const res = await axiosInstance.post(
                "HsnCode/RetriveGstSubChapAll",
                { HsnSubChp_Key: currentHsnSubChp_Key, Flag: flag }
            );
            const { Status, Data } = res.data;
            if (Status === 0 && Data?.GstSubChapSlabEntities?.[0]) {
                const key = Data.GstSubChapSlabEntities[0].HsnSubChp_Key;
                if (key && key !== currentHsnSubChp_Key) await fetchRetriveData(key, "R");
                // else toast.info(flag === "P" ? "First record" : "Last record");
            }
        } catch (e) {
            toast.error("Navigation error");
        }
    };
    const handlePrevious = () => navigateRecord("P");
    const handleNext = () => navigateRecord("N");

    const handleEdit = () => {
        setMode(FORM_MODE.edit);
        setIsFormDisabled(false);
    };

    const fetchNextHsnCodeKey = async () => {
        try {
            const res = await axiosInstance.post('/HsnCode/GetSeriesLastNewKey', {
                ModuleName: "GstSubChap",
                TblName: "GstSubChap",
                ColName: "HsnSubChp_Key",
                Ncollen: 5,
                CPrefix: "GS",
                FLAG: ""
            });

            if (res.data.Status === 0 && res.data.Data?.[0]?.DocKey) {
                return res.data.Data[0].DocKey;
            }
            throw new Error("Invalid response");
        } catch (err) {
            console.error("Failed to generate HSN Code Key");
            return "GH001";
        }
    };
    const handleAdd = async () => {
        const nextKey = await fetchNextHsnCodeKey();

        setCurrentHsnSubChp_Key(nextKey);
        setMode(FORM_MODE.add);
        setIsFormDisabled(false);

        setFormData({
            HsnSubChp_Key: nextKey,
            HsnChp_Key: "",
            HsnSubChap_Name: "",
            HsnSubChap_Desc: "",
            Multi_Sab: "S",
            Mrp_Wsp_App: "M",
            Taxable_Exempted: "T",
            Remk: "",
            Status: "1",
            GstPeriods_Key: "",
            FromDate: "",
            ToDate: "",
        });

        setGstRateSlab("Single");
        setGstApplication("Taxable");
        setApplicableOn("RSP/MRP");

        // Reset GST Rate Rows to default (Single mode)
        setGstRateRows([{
            ...DEFAULT_ROW,
            BASERate: "0",
            BASERateTo: "0",
        }]);

        setTimeout(() => HsnSubChap_NameRef.current?.focus(), 100);
    };


    const handleExit = () => {
        navigate("/gst-sub-chapter-heading-table", { replace: true });
    };

    const handleDelete = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        setOpenConfirmDialog(false);
        try {
            const response = await axiosInstance.post(
                `HsnCode/DeleteGstSubChap`,
                {
                    HsnSubChp_Key: currentHsnSubChp_Key,
                }
            );
            const {
                data: { Status, Message, Data },
            } = response;
            if (Status === 0) {
                toast.success(Message, { autoClose: 1000 });
                await fetchRetriveData(currentHsnSubChp_Key, "N");
            } else {
                toast.error(Message, { autoClose: 1000 });
            }
            await fetchRetriveData(currentHsnSubChp_Key, "N");
            setMode(FORM_MODE.read);
            setIsFormDisabled(true);
        } catch (error) {
            return error;
        }
    };

    // const handleChangeStatus = (event) => {
    //     const updatedStatus = event.target.checked ? "1" : "0";
    //     setStatus(updatedStatus);
    //     setFormData((prevState) => ({
    //         ...prevState,
    //         Status: updatedStatus,
    //     }));
    // };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            // Prevent form submission on Enter
            event.preventDefault();
            if (event.target === HsnSubChap_NameRef.current) {
                HsnSubChap_DescRef.current?.focus();
            } else if (event.target === HsnSubChap_DescRef.current) {
                RemkRef.current?.focus();
            } else {
                // Optional: focus next logical field or submit
                RemkRef.current?.focus();
            }
        }
    };

    const mapRateRows = (rows, hsnKey, uid, isMultiple, mode) =>
        rows.map((r) => {
            const isInsert = !r.Gst_Rate_Slab_Id || r.Gst_Rate_Slab_Id === 0;
            const baseObj = {
                DBFLAG: isInsert ? "I" : "U",
                Gst_Rate_Slab_Id: r.Gst_Rate_Slab_Id || 0,
                HsnSubChp_Key: hsnKey,
                Base_Rate: isMultiple ? Number(r.BASERate) || 0 : 0,
                Base_Rate_To: isMultiple ? Number(r.BASERateTo) || 0 : 0,
                Base_Desc: "",
                Sgst_Rate: Number(r.SGSTRate) || 0,
                Cgst_Rate: Number(r.CGSTRate) || 0,
                Igst_Rate: Number(r.IGSTRate) || 0,
                Add_Cess: Number(r.AddCESS) || 0,
                Remk: "",
                Status: "1",
            };

            // Only add Created_By for INSERT rows
            if (isInsert) {
                return { ...baseObj, Created_By: uid };
            }
            // Only add Updated_By for UPDATE rows
            return { ...baseObj, Updated_By: uid };
        });

    const validateRateRows = (rows, isMultiple) => {
        const errors = [];

        if (!isMultiple) return errors;

        rows.forEach((r, idx) => {
            const base = Number(r.BASERate) || 0;
            const to = Number(r.BASERateTo) || 0;

            if (base < 1) {
                errors.push(`Row ${idx + 1}: Base Rate must be ≥ 1 (currently ${base})`);
            }

            if (to !== 0 && to <= base) {
                errors.push(`Row ${idx + 1}: Base Rate To (${to}) must be greater than Base Rate (${base})`);
            }

            if (to > 0 && base < 1) {
                errors.push(`Row ${idx + 1}: Base Rate must be ≥ 1 when Base Rate To is filled`);
            }
        });

        return errors;
    };

    const handleSubmit = async () => {
        if (mode === FORM_MODE.read) return;

        if (!formData.HsnSubChap_Name?.trim()) {
            toast.error("Sub Chapter Code is required");
            return;
        }
        if (!formData.HsnChp_Key) {
            toast.error("GST Chapter is required");
            return;
        }
        // ---- NEW: validate the rate-slab rows ------------------------------------
        const slabErrors = validateRateRows(gstRateRows, gstRateSlab === "Multiple");
        if (slabErrors.length > 0) {
            slabErrors.forEach(msg => toast.error(msg));
            return;                     // stop submission
        }

        const isAdd = mode === FORM_MODE.add;
        const uid = parseInt(UserId, 10);

        const payload = {
            DBFLAG: isAdd ? "I" : "U",
            HsnSubChp_Key: currentHsnSubChp_Key,
            HsnChp_Key: formData.HsnChp_Key,
            HsnSubChap_Name: formData.HsnSubChap_Name,
            HsnSubChap_Desc: formData.HsnSubChap_Desc || "",
            Taxable_Exempted: gstApplication === "Taxable" ? "T" : "E",
            Multi_Sab: gstRateSlab === "Single" ? "S" : "M",
            Mrp_Wsp_App: applicableOn === "RSP/MRP" ? "M" : "W",
            Remk: formData.Remk || "",
            Status: formData.Status,
            GST_P_ID: formData.GstPeriods_Key ? parseInt(formData.GstPeriods_Key, 10) : null, // Send GST_P_ID
            ...(isAdd ? { Created_By: uid } : { Updated_By: uid }),
            Gst_Rate_SlabEntities: mapRateRows(
                gstRateRows,
                currentHsnSubChp_Key,
                uid,
                gstRateSlab === "Multiple"
            ),
        };

        // Remove null/undefined fields (optional, keeps payload clean)
        const cleanPayload = Object.fromEntries(
            Object.entries(payload).filter(([_, v]) => v !== null && v !== undefined)
        );

        try {
            const res = await axiosInstance.post("/HsnCode/MangeGstSubChap", cleanPayload);
            if (res.data.Status === 0) {
                toast.success(res.data.Message ?? "Saved", { autoClose: 1000 });
                if (isAdd) {
                    setCurrentHsnSubChp_Key(res.data.Data?.HsnSubChp_Key ?? currentHsnSubChp_Key);
                    await fetchRetriveData(res.data.Data?.HsnSubChp_Key ?? currentHsnSubChp_Key, "R");
                }
                setMode(FORM_MODE.read);
                setIsFormDisabled(true);
            } else {
                toast.error(res.data.Message ?? "Error");
            }
        } catch (e) {
            toast.error(e?.response?.data?.Message ?? "Network error");
        }
    };

    const handleCancel = async () => {
        if (mode === FORM_MODE.add) {
            try {
                await fetchRetriveData(1, "L");
                setMode(FORM_MODE.read);
                setIsFormDisabled(true);
            } catch (error) {
                toast.error('Error occurred while cancelling. Please try again.');
            }
        } else if (mode === FORM_MODE.edit) {
            if (currentHsnSubChp_Key) {
                await fetchRetriveData(currentHsnSubChp_Key, "R");
            }
            setMode(FORM_MODE.read);
            setIsFormDisabled(true);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const handleRateSlabChange = (e) => {
        const value = e.target.value;
        const isMultiple = value === "Multiple";
        setGstRateSlab(value);

        if (gstRateRows.length > 0 && gstRateRows[0].Gst_Rate_Slab_Id) {
            const firstRow = { ...gstRateRows[0] };
            if (isMultiple) {
                firstRow.BASERate = "1";
                firstRow.BASERateTo = "0";
            } else {
                firstRow.BASERate = "0";
                firstRow.BASERateTo = "0";
                firstRow.BaseRateIncl = "0";
                firstRow.BaseRateInclTo = "0";
            }
            setGstRateRows([firstRow]);
        } else {
            const defaultRow = { ...DEFAULT_ROW };
            defaultRow.BASERate = isMultiple ? "1" : "0";
            if (!isMultiple) defaultRow.BASERateTo = "0";
            setGstRateRows([defaultRow]);
        }
    };

    return (
        <>
            <Box
                className="form-container"
                sx={{
                    width: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                    maxWidth: { xs: "calc(100vw - 60px)", sm: "auto", md: "auto" },
                    overflowX: "hidden",
                    overflowY: { xs: "auto", sm: "hidden", md: "hidden" },
                }}
            >
                <ToastContainer />
                <Grid
                    container
                    spacing={2}
                    sx={{
                        width: { xs: "93%", sm: "80%", md: "80%" },
                        height: { xs: "460px", sm: "auto", md: "auto" },
                        margin: "auto",
                        marginTop: { xs: "60px", sm: 0, md: "auto" },
                        marginBottom: { xs: "110px", sm: 0, md: "auto" },
                        borderRadius: "8px",
                        padding: { xs: "0px 5px 5px 5px", sm: "0px 20px 20px 20px" },
                        backgroundColor: "#fff",
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "30px",
                            marginInline: { xs: "0px", sm: "2px", md: "20px" },
                            flexDirection: { xs: "column", sm: "row", md: "row" },
                            overflow: "hidden",
                        }}
                    >
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", sm: "flex-start" },
                                marginBottom: { xs: "10px", sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{
                                    backgroundColor: "#635BFF",
                                    marginRight: { xs: "0px", sm: "10px" },
                                    display: "block",
                                }}
                                disabled={
                                    mode !== FORM_MODE.read ||
                                    !currentHsnSubChp_Key ||
                                    currentHsnSubChp_Key === 1
                                }
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{
                                    backgroundColor: "#635BFF",
                                    display: "block",
                                }}
                                disabled={mode !== FORM_MODE.read || !currentHsnSubChp_Key}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>
                        <Typography
                            variant="h5"
                            sx={{
                                margin: "auto",
                                textAlign: { xs: "center", sm: "center" },
                                fontSize: { xs: "22px", sm: "18px", md: "24px" },
                            }}
                        >
                            GST Sub Chapter Heading
                        </Typography>
                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName="Gst Sub Chapter Heading"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                                onView={handlePrint}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={mode === FORM_MODE.read}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        lg={12}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            mx: "auto",
                        }}
                    >
                        <Grid
                            container
                            spacing={1}
                            justifyContent="center"
                            sx={{ maxWidth: "800px", width: "100%" }}
                        >
                            <Grid item xs={12} md={10}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="HsnSubChp_Key"
                                            name="HsnSubChp_Key"
                                            label="Code"
                                            variant="filled"
                                            fullWidth
                                            disabled={true}
                                            className="custom-textfield"
                                            value={formData.HsnSubChp_Key}
                                            onChange={handleInputChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <Autocomplete
                                            disabled={mode !== FORM_MODE.add}
                                            options={gstChapterOptions}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={gstChapterOptions.find((opt) => opt.value === formData.HsnChp_Key) || null}
                                            onChange={(event, newValue) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    HsnChp_Key: newValue ? newValue.value : "",
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={
                                                        <>
                                                            Gst Chapter <span style={{ color: "red" }}>*</span>
                                                        </>
                                                    }
                                                    variant="filled"
                                                    fullWidth
                                                    className="custom-textfield"
                                                    onKeyDown={handleKeyPress}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={10}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            id="HsnSubChap_Name"
                                            name="HsnSubChap_Name"
                                            label={
                                                <>
                                                    Sub Chp. Code <span style={{ color: "red" }}>*</span>
                                                </>
                                            }
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={formData.HsnSubChap_Name}
                                            onChange={handleInputChange}
                                            disabled={mode === FORM_MODE.read}
                                            inputRef={HsnSubChap_NameRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={9}>
                                        <TextField
                                            id="HsnSubChap_Desc"
                                            name="HsnSubChap_Desc"
                                            fullWidth
                                            label="Description"
                                            value={formData.HsnSubChap_Desc}
                                            onChange={handleInputChange}
                                            variant="filled"
                                            disabled={mode === FORM_MODE.read}
                                            className="custom-textfield"
                                            inputRef={HsnSubChap_DescRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={10}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'row',
                                    gap: 2,
                                }}
                            >
                                <FormLabel
                                    component="legend"
                                    sx={{
                                        fontWeight: 500,
                                        whiteSpace: 'nowrap',
                                        mr: 2,
                                    }}
                                >
                                    GST Application
                                </FormLabel>

                                <RadioGroup
                                    row
                                    name="gstApplication"
                                    value={gstApplication}
                                    onChange={(e) => setGstApplication(e.target.value)}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    }}
                                >
                                    <FormControlLabel
                                        value="Taxable"
                                        control={<Radio />}
                                        label="Taxable"
                                        disabled={mode === FORM_MODE.read}
                                        sx={{ mr: 2 }}
                                    />
                                    <FormControlLabel
                                        value="Exempted"
                                        control={<Radio />}
                                        label="Exempted"
                                        disabled={mode === FORM_MODE.read}
                                    />
                                </RadioGroup>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={10}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'row',
                                    gap: 2,
                                    flexWrap: 'wrap',
                                }}
                            >
                                {/* GST Rate Slab */}
                                <Box sx={{ display: 'flex', alignItems: 'center', mr: 3 }}>
                                    <FormLabel
                                        component="legend"
                                        sx={{ fontWeight: 500, whiteSpace: 'nowrap', mr: 1.5 }}
                                    >
                                        GST Rate Slab
                                    </FormLabel>
                                    <RadioGroup
                                        row
                                        value={gstRateSlab}
                                        onChange={handleRateSlabChange}
                                        sx={{ display: 'flex', alignItems: 'center' }}
                                    >
                                        <FormControlLabel
                                            value="Single"
                                            control={<Radio size="small" />}
                                            label="Single"
                                            disabled={mode === FORM_MODE.read}
                                            sx={{ mr: 1 }}
                                        />
                                        <FormControlLabel
                                            value="Multiple"
                                            control={<Radio size="small" />}
                                            label="Multiple"
                                            disabled={mode === FORM_MODE.read}
                                        />
                                    </RadioGroup>
                                </Box>

                                {gstRateSlab === "Multiple" && (
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <FormLabel component="legend" sx={{ fontWeight: 500, whiteSpace: 'nowrap', mr: 1.5 }}>
                                            Applicable On
                                        </FormLabel>
                                        <RadioGroup
                                            row
                                            value={formData.Mrp_Wsp_App === "M" ? "RSP/MRP" : "NetSaleRs"}
                                            onChange={(e) => {
                                                const value = e.target.value === "RSP/MRP" ? "M" : "W";
                                                setFormData(prev => ({ ...prev, Mrp_Wsp_App: value }));
                                            }}
                                            sx={{ display: 'flex', alignItems: 'center' }}
                                        >
                                            <FormControlLabel
                                                value="RSP/MRP"
                                                control={<Radio size="small" />}
                                                label="RSP/MRP"
                                                disabled={mode !== FORM_MODE.add}
                                                sx={{ mr: 1 }}
                                            />
                                            <FormControlLabel
                                                value="NetSaleRs"
                                                control={<Radio size="small" />}
                                                label="Net Sale Rs"
                                                disabled={mode !== FORM_MODE.add}
                                            />
                                        </RadioGroup>
                                    </Box>
                                )}

                            </Grid>

                            <Grid item xs={12} md={10}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={10}>
                                        <TextField
                                            fullWidth
                                            label="Remark"
                                            name="Remk"
                                            value={formData.Remk}
                                            onChange={handleInputChange}
                                            variant="filled"
                                            disabled={mode === FORM_MODE.read}
                                            className="custom-textfield"
                                            inputRef={RemkRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <FormGroup sx={{ flexShrink: 0 }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        disabled={mode === FORM_MODE.read}
                                                        // checked={Status === "1"}
                                                        checked={formData.Status === "1"}
                                                        // onChange={handleChangeStatus}
                                                        // You can remove handleChangeStatus entirely and use inline:
                                                        onChange={(e) => {
                                                            const newStatus = e.target.checked ? "1" : "0";
                                                            setFormData(prev => ({ ...prev, Status: newStatus }));
                                                        }}
                                                    />
                                                }
                                                label="Status"
                                            />
                                        </FormGroup>
                                    </Grid>
                                </Grid>
                            </Grid>


                            <Grid item xs={12} md={10}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <Autocomplete
                                            disabled={mode === FORM_MODE.read}
                                            options={gstPeriodOptions}
                                            getOptionLabel={(option) => option.label || ""}
                                            value={
                                                gstPeriodOptions.find((opt) => opt.value === formData.GstPeriods_Key) || null
                                            }
                                            onChange={(event, newValue) => {
                                                if (newValue) {
                                                    const fromDate = newValue.from?.split("T")[0] || "";
                                                    const toDate = newValue.to?.split("T")[0] || "";

                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        GstPeriods_Key: newValue.value,
                                                        FromDate: fromDate,
                                                        ToDate: toDate,
                                                    }));
                                                } else {
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        GstPeriods_Key: "",
                                                        FromDate: "",
                                                        ToDate: "",
                                                    }));
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="GST Period"
                                                    variant="filled"
                                                    fullWidth
                                                    className="custom-textfield"
                                                    onKeyDown={handleKeyPress}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            fullWidth
                                            label="From Date"
                                            name="FromDate"
                                            type="date"
                                            value={formData.FromDate || ""}
                                            onChange={handleInputChange}
                                            InputLabelProps={{ shrink: true }}
                                            variant="filled"
                                            disabled={true}
                                            className="custom-textfield"
                                            inputProps={{ max: formData.ToDate || undefined }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            fullWidth
                                            label="To Date"
                                            name="ToDate"
                                            type="date"
                                            value={formData.ToDate || ""}
                                            onChange={handleInputChange}
                                            InputLabelProps={{ shrink: true }}
                                            variant="filled"
                                            disabled={true}
                                            className="custom-textfield"
                                            inputProps={{ min: formData.FromDate || undefined }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <GstRateTable
                                rows={gstRateRows}
                                onRowsChange={setGstRateRows}
                                disabled={mode === FORM_MODE.read}
                                rateSlabType={gstRateSlab}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        className="form_button"
                        sx={{ marginBottom: "10px", marginInline: "20px" }}
                    >
                        {mode === FORM_MODE.read && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleSubmit}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleCancel}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        "@media (max-width: 600px)": {
                                            padding: "0px 0px !important",
                                        },
                                    }}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>

                <div style={{ display: "none" }}>
                    {rows.length > 0 && (
                        <ReportTable
                            columns={columns}
                            rows={rows.map(row => ({
                                ...row,
                                Status: row.Status === "1" ? "Active" : row.Status === "0" ? "Inactive" : row.Status,
                                Multi_Sab: row.Multi_Sab == "M" ? "Multiple" : row.Multi_Sab == "S" ? "Single" : row.Multi_Sab,
                                Taxable_Exempted: row.Taxable_Exempted == "T" ? "Taxable" : row.Taxable_Exempted == "E" ? "Exempted" : row.Taxable_Exempted,
                                Mrp_Wsp_App: row.Mrp_Wsp_App === "M" ? "RSP/MRP" : row.Mrp_Wsp_App == "W" ? "NetSaleRs" : row.Mrp_Wsp_App
                            }))}
                            title="GST Sub Chapter Heading Master"
                            contentRef={contentRef}
                            customStyles={{ backgroundColor: "#f5f5f5" }}
                        />
                    )}
                </div>
                <Dialog
                    open={openConfirmDialog}
                    onClose={handleCloseConfirmDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete this record?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            sx={{
                                backgroundColor: "#635bff",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "#1565c0",
                                    color: "white",
                                },
                            }}
                            onClick={handleConfirmDelete}
                        >
                            Yes
                        </Button>
                        <Button
                            sx={{
                                backgroundColor: "#635bff",
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "#1565c0",
                                    color: "white",
                                },
                            }}
                            onClick={handleCloseConfirmDialog}
                        >
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box > {/* Added closing Box tag */}
        </>
    );
};

export default GstSubChapHdMst;